// withNeoAuthenticationRequired.js
import { withAuthenticationRequired } from "@auth0/auth0-react";
import { NeoAuth0Context } from "./neoAuth0Context";

export const withNeoAuthenticationRequired = (Component, options = {}) =>
  withAuthenticationRequired(Component, {
    ...options,
    context: NeoAuth0Context,
  });
